module.exports = __webpack_public_path__ + "img/private-napolimania-pizza-2.03fa7f27.jpg";